import type { EmailTemplateItem } from "sj-ui-toolkit/src/api/admin/comms.email";
import type { RefMap } from "@/components/email/EmailTemplateContext";

const transformDiv = (element: HTMLElement) => {
  let div = element.querySelector("div");
  while (div) {
    const br = document.createElement("br");
    const text = document.createTextNode(div.innerText);
    div.replaceWith(br, text);
    div = element.querySelector("div");
  }
};

export const getTemplatesData = (
  data: RefMap,
  template: EmailTemplateItem[]
): EmailTemplateItem[] => {
  const result: EmailTemplateItem[] = [];

  Object.keys(data.current).forEach(key => {
    const index = Number(key);
    const htmlObject = template[index];
    if (!htmlObject) return;

    const element = data.current[index]?.current;
    if (element) {
      transformDiv(element);
      result.push({ ...htmlObject, text: element.innerHTML });
    } else {
      result.push({ ...htmlObject, text: "" });
    }
  });

  return result;
};
